export default "__VITE_ASSET__B0DhwQ54__"